import { render, staticRenderFns } from "./PriceListOutOfRangeSlot.vue?vue&type=template&id=93ba5142&scoped=true"
import script from "./PriceListOutOfRangeSlot.vue?vue&type=script&lang=ts"
export * from "./PriceListOutOfRangeSlot.vue?vue&type=script&lang=ts"
import style0 from "./PriceListOutOfRangeSlot.vue?vue&type=style&index=0&id=93ba5142&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ba5142",
  null
  
)

export default component.exports